import { t } from "i18next";
import { Button, Form, Modal, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Athlete, AthletePerformance, emptyAthlete } from "../../../../interfaces/athlete";
import { createAthletePerformance, getAthletePerformance, getAthleteSingle } from "../../../../services/athlete";
import { Media } from "../../../../interfaces/media";
import DataTable from "react-data-table-component";
import moment from "moment";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { getPaginationOptions, tableStyles } from "../../../../util/data-table";
import { useKpiLabels } from "../../../../hooks/useKpiLabels";

interface CoachAthletePerformanceProps {
    id: number;
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function CoachAthletePerformance(props: CoachAthletePerformanceProps) {
    const { kpiLabels, loaded: kpiLabelsLoaded } = useKpiLabels();
    const [athlete, setAthlete] = useState<Athlete>(emptyAthlete);
    const [media, setMedia] = useState<Media[]>([]);
    const [loaded, setLoaded] = useState(true);
    const [athletePerformances, setAthletePerformances] = useState<AthletePerformance[]>([]);
    const [showAdd, setShowAdd] = useState(false);

    useEffect(() => {
        Promise.all([
            getAthleteSingle(props.id),
            getAthletePerformance(props.id)
        ]).then((response: any) => {
            setAthlete(response[0].data);
            const newMedia = response[0].data.avatar.map((m: Media) => {
                return m;
            });
            setMedia(newMedia);
            setAthletePerformances(response[1].data);
            setLoaded(true);
        });
    }, []);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            athlete_id: athlete.id,
            performance_date: event.target.performance_date.value,
            perf1: event.target.perf1.value,
            perf2: event.target.perf2.value,
            perf3: event.target.perf3.value,
            perf4: event.target.perf4.value
        }
        createAthletePerformance(body)
            .then((response: any) => {
                if (response.data.status == 1) {
                    const newAthletePerformances = [
                        ...response.data.data,
                        ...athletePerformances
                    ];
                    setAthletePerformances(newAthletePerformances);
                    setShowAdd(false);
                } else {
                    alert(response.data.message);
                }
            })
            .catch((error: any) => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleDelete = () => {

    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(true);
    }

    const handleCloseAddNew = (event: any) => {
        event.preventDefault();
        setShowAdd(false);
    }
    
    const CustomActions = (row: any) => (
        <span>
            {/*<a href="#" className="icon-link edit" title={ t("edit") } onClick={ handleEdit } data-id={ row.row.id }>
                <i className="bi bi-pencil-square"></i>
            </a>*/}
            <a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ row.row.id }>
                <i className="bi bi-trash"></i>
            </a>
        </span>
    );

    const CustomDate = (row: any ) => (
        <span>
            { moment(row.row.performance_date).format("DD/MM/YYYY") }
        </span>
    );

    const columns = [
        {
            id: 'id',
            name: '#',
            style: { maxWidth: '80px' },
            selector: (row: any) => row.id,
            sortable: true
        },
        {
            id: 'performance_date',
            name: t('performance_date'),
            selector: (row: any) => row.athlete_name,
            sortable: true,
            cell: (row: any) => <CustomDate row={row} />,
        },
        {
            id: 'perf1',
            name: kpiLabels.perf1 || t('perf1_label'),
            selector: (row: any) => row.perf1,
            sortable: true
        },
        {
            id: 'perf2',
            name: kpiLabels.perf2 || t('perf2_label'),
            center: true,
            selector: (row: any) => row.perf2,
            sortable: true
        },
        {
            id: 'perf3',
            name: kpiLabels.perf3 || t('perf3_label'),
            center: true,
            selector: (row: any) => row.perf3,
            sortable: true
        },
        {
            id: 'perf4',
            name: kpiLabels.perf4 || t('perf4_label'),
            center: true,
            selector: (row: any) => row.perf4,
            sortable: true
        },
        {
            id: 'actions',
            name: t("actions"),
            cell: (row: any) => <CustomActions row={row} />,
        }

    ];
    
    return (
        <Modal className="admin-athlete-performance-container" show={ true }
            onHide={ handleClose } size="xl"> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("athlete_performances") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { !loaded && 
                    <LoadingSpinner />
                }
                { loaded &&
                    <div className="athlete-performances-container">
                        <div className="subtable-container">
                            <DataTable
                                columns={ columns }
                                data={athletePerformances}
                                // selectableRows={ true }
                                // selectableRowsHighlight={ true }
                                responsive={ true }
                                striped={ true }
                                highlightOnHover={ true }
                                defaultSortFieldId={ 'performance_date' }
                                defaultSortAsc={ false }
                                pagination={ true }
                                customStyles={ tableStyles }
                                paginationComponentOptions={ getPaginationOptions() }
                            />
                        </div>
                        { !showAdd &&
                            <a className="performance-add-new" href="#" onClick={ handleAddNew }>
                                <i className="bi bi-plus-circle"></i>
                            </a>
                        }
                        { showAdd && 
                            <Form onSubmit={ handleSave } className="add-performance">
                                <a href="#" className="close" onClick={ handleCloseAddNew }>
                                </a>
                                <div className="fields">
                                    <Form.Control type="hidden" name="id" required defaultValue={ athlete.id } />
                                    <Form.Group className="mb-3" controlId="performance_date">
                                        <Form.Label aria-required="true">{ t("performance_date") }</Form.Label>
                                        <Form.Control type="date" name="performance_date" required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="perf1">
                                        <Form.Label aria-required="true">{ kpiLabels.perf1 || t("perf1_label") }</Form.Label>
                                        <Form.Control type="number" name="perf1" required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="perf2">
                                        <Form.Label aria-required="true">{ kpiLabels.perf2 || t("perf2_label") }</Form.Label>
                                        <Form.Control type="number" name="perf2" required />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="perf3">
                                        <Form.Label aria-required="true">{ kpiLabels.perf3 || t("perf3_label") }</Form.Label>
                                        <Form.Control type="number" name="perf3" />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="perf4">
                                        <Form.Label aria-required="true">{ kpiLabels.perf4 || t("perf4_label") }</Form.Label>
                                        <Form.Control type="number" name="perf4" />
                                    </Form.Group>
                                </div>
                                <div className="actions">
                                    <Button type="submit" variant="primary">
                                        { t("Save") }
                                    </Button>
                                    {/*<Button variant="secondary" onClick={ handleCloseAddNew }>
                                        { t("Close") }
                                    </Button>*/}
                                </div>
                            </Form>
                        }
                    </div>
                }
            </Modal.Body>
        </Modal>
    );
}